import { DateValue } from "@mantine/dates"
import { Tenant } from "./tenant.model"
import { Unit } from "./unit.model"
import { Property } from "./property.model"
import { AnyObjectSchema } from "yup"

export type Lease = {
  id?: string
  name?: string
  startDate?: DateValue
  endDate?: DateValue
  rentAmount?: number
  totalRentAmount?: number
  securityDepositType?: string
  securityDepositFileName?: string
  securityDepositAmount?: number
  minioSecurityDeposits?: string[]
  securityDeposit?: AnyObjectSchema
  paymentFrequency?: PaymentFrequency
  leaseStatus: LeaseStatus
  leaseType?: LeaseType
  paymentDueDate?: DateValue
  lateFeeAmount?: number
  lateFeeType?: string
  gracePeriod?: number
  terminationNotice?: number
  enabled?: boolean
  terminatedAt?: DateValue
  tenantId?: string
  tenant?: Tenant
  unitId?: string
  unit?: Unit
  propertyId?: string
  property?: Property
  autoRenewal?: boolean
  notes?: string
  utilityFee?: number
  leaseFilenames?: string[]
  minioLeases?: string[]
  lease?: any
  archiveReason?: string
  createdBy?: string
  updatedBy?: string
  createdAt?: Date
  updatedAt?: Date
  deletedAt?: Date
  deletedBy?: string

  internalEndDate?: DateValue
  internalStartDate?: DateValue

  discountAmount?: number
  discountEndDate?: DateValue
  discountType?: string
}

export enum PaymentFrequency {
  Monthly = "Monthly",
  TwoMonths = "TwoMonths",
  Quarterly = "Quarterly",
  FourMonths = "FourMonths",
  FiveMonths = "FiveMonths",
  SixMonths = "SixMonths",
  SevenMonths = "SevenMonths",
  EightMonths = "EightMonths",
  NineMonths = "NineMonths",
  TenMonths = "TenMonths",
  ElevenMonths = "ElevenMonths",
  Annually = "Annually",
}

export enum LeaseStatus {
  Active = "Active",
  Terminated = "Terminated",
  Expired = "Expired",
  Pending = "Pending",
  Completed = "Completed",
}
export enum LeaseType {
  FixedTerm = "Fixed-term",
  MonthToMonth = "Month-to-Month",
  Sublease = "Sublease",
}
